"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryCheckoutSkeleton = BasisTheoryCheckoutSkeleton;
var _react = _interopRequireDefault(require("react"));
var SKELETON_BLOCK = 'animate-pulse rounded bg-gray-200';
/** Render the new-card form shape while stored-card routing is being resolved. */
function BasisTheoryCheckoutSkeleton(_ref) {
  var _ref$embedded = _ref.embedded,
    embedded = _ref$embedded === void 0 ? false : _ref$embedded;
  var shellClassName = embedded ? 'bg-white' : 'mt-5 rounded-[14px] border border-gray-200 bg-white p-[14px] shadow-[0_4px_18px_rgba(15,23,42,0.08)]';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: shellClassName,
    "data-testid": "basis-theory-checkout-skeleton",
    "aria-busy": "true",
    "aria-live": "polite",
    "data-sentry-component": "BasisTheoryCheckoutSkeleton",
    "data-sentry-source-file": "BasisTheoryCheckoutSkeleton.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-4 px-5 pb-4 pt-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-3 md:flex-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-1 flex-col gap-2 md:flex-[5]"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-4 w-28")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-[46px] w-full rounded-[10px] md:h-[50px]")
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-3 md:flex-[4.5]"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-0 flex-1 flex-col gap-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-4 w-20")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-[46px] w-full rounded-[10px] md:h-[50px]")
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-0 flex-1 flex-col gap-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-4 w-12")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-[46px] w-full rounded-[10px] md:h-[50px]")
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex max-w-full flex-col gap-2 md:max-w-[calc(50%_-_6px)]"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-4 w-32")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-[46px] w-full rounded-[10px] md:h-[50px]")
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-start gap-3 border-t border-gray-100 pt-5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-5 w-5 rounded-full")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-1 flex-col gap-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-4 w-40")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-3 w-full")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(SKELETON_BLOCK, " h-3 w-3/4")
  })))));
}